const PARENT_REGEX = /^\$\$PARENT([0-9]+)\.(.*)/;

export default (field, relative) => {
  const matched = relative.match(PARENT_REGEX);

  if (matched) {
    const relativeParts = field.split('.').slice(0, matched[1] * -1);
    relativeParts.push(matched[2]);

    return relativeParts.join('.');
  }

  return relative;
};
